export default __webpack_public_path__ + "static/media/upload.e3888757.svg";